import { useHistory } from "react-router-dom"
import ServicosContext from "./contexts/servicosContext"
import Routes, { alertStart } from "./routes"
import { Parametros, parametrosId } from "./services/integracao"
import { useSnackbar } from "./utils/notificacoes"

import { useEffect } from "react"
import useParametros from "./contexts/ParametrosContext"
import RepresentanteSelector from "./functions/RepresentanteSelector"
import { DialogAvisoFatura } from "./pages/DialogAvisoFaturas"
import { RegistrarLogErro } from "./services/clientefiel"
import { getIdEstabelecimentoAtual } from "./services/quitacaoAutomatica"
import useAppStore from "./stores/AppStore"
import useLoadingStore from "./stores/LoadingStore"

export default function Permissoes() {
    const setLoading = useLoadingStore(s => s.setLoading)

    const autorizacao = localStorage.getItem("chaveSistema")
    const history = useHistory()

    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)
    const configuracoes = useAppStore(s => s.configuracoes)
    const parametros = useParametros()

    const estabelecimentoId = configuracoes?.user?.parametros?.estabelecimento?.id
    const { enqueueSnackbar } = useSnackbar()

    const acessarImagensTematicas = () => {
        try {
            if (configuracoes.user.parametros.urlSiteAplicativo) {
                window.open(
                    `https://${configuracoes.user.parametros.urlSiteAplicativo
                        .replace("https://", "")
                        .replace("http://", "")
                        .replace("/", "")}/downloads/imagensTematicas`,
                    "_blank"
                )
            } else {
                enqueueSnackbar(
                    "Seu usuário não está associado a nenhum gerador de imagens temáticas. Procure a equipe do suporte.",
                    { warning: "error" }
                )
            }
        } catch (error) {
            enqueueSnackbar(
                "Seu usuário não está associado a nenhum gerador de imagens temáticas. Procure a equipe do suporte.",
                { warning: "error" }
            )
        }
    }

    const buscarParametros = async () => {
        if (estabelecimentoId) {
            try {
                const response = await parametrosId(estabelecimentoId, autorizacao)

                if (response.retornoErro) {
                    enqueueSnackbar(response.mensagem, { variant: "error" })
                    return {}
                }

                setLoading(false)
                configuracoes.user.parametros = response

                atualizarConfiguracoes(configuracoes)

                return configuracoes.user.parametros
            } catch (error) {
                RegistrarLogErro(error, "buscarParametros")
            }
        }

        return {}
    }

    const buscarParametrosLogin = async (auth = autorizacao) => {
        try {
            const response = await Parametros(auth)
            if (response.retornoErro) {
                enqueueSnackbar(response.mensagem, { variant: "error" })
                return {}
            }

            setLoading(false)

            return response
        } catch (error) {
            RegistrarLogErro(error, "buscarParametros")
        }
        return {}
    }

    const handlePedidoDeMesa = async () => {
        setLoading(true)
        try {
            const parametros = await buscarParametros()
            if (parametros?.id) {
                if (parametros?.possuiModuloPedidosMesa) {
                    if (parametros?.urlSiteAplicativo) {
                        history.push("/servicos/modulo/gerenciador-de-mesas")
                        if (!window.getCookie("infoGerenciarMesas")) {
                            enqueueSnackbar("Aqui você pode gerenciar suas mesas.")
                            window.setCookie("infoGerenciarMesas", "true", 9999)
                        }
                    } else {
                        enqueueSnackbar(
                            "Seu usuário não está associado a nenhum gerenciador de mesas. Procure a equipe do suporte.",
                            { variant: "error" }
                        )
                    }
                } else {
                    enqueueSnackbar(
                        "Esse usuário não possui Módulo de pedido de mesa contratado.",
                        { variant: "warning" }
                    )
                }
            } else {
                enqueueSnackbar("Erro ao identificar se você possui esse Módulo.", {
                    variant: "warning",
                })
            }
        } catch (error) {
            enqueueSnackbar(
                "Seu usuário não está associado a nenhum gerador de qrcodes de mesa. Procure a equipe do suporte.",
                { variant: "error" }
            )
        }
        setLoading(false)
    }

    const handleAceitadorDePedidos = async () => {
        setLoading(true)
        try {
            const parametros = await buscarParametros()

            if (parametros.id) {
                localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
                history.push("/servicos/modulo/recebedor-de-pedidos")
                if (!window.getCookie("infoRecebedor")) {
                    enqueueSnackbar("Aqui você recebe os seus pedidos.")
                    window.setCookie("infoRecebedor", "true", 9999)
                }
            } else {
                enqueueSnackbar("Infelizmente você está com o Delivery Inativo.", {
                    variant: "warning",
                })
            }
        } catch (error) {
            enqueueSnackbar("Houve um erro ao direcionar para o recebedor de pedidos.", {
                variant: "error",
            })

            RegistrarLogErro(error, "recebedorDePedidos")
        }
        setLoading(false)
    }

    const handleRegistradorDePedidos = async (acao = false) => {
        try {
            if (acao && configuracoes?.user?.parametros?.exibirRegistroPedidos === true) {
                acao()
                return true
            }
            setLoading(true)
            const parametros = await buscarParametros()

            if (parametros.exibirRegistroPedidos === true) {
                localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
                history.push("/servicos/modulo/registrador-de-pedidos")
                if (!window.getCookie("infoRegistrador")) {
                    enqueueSnackbar("Aqui você registra pedidos para seus clientes.")
                    window.setCookie("infoRegistrador", "true", 9999)
                }
            } else {
                enqueueSnackbar("Esse usuário não possui registrador de pedidos contratado.", {
                    variant: "warning",
                })
            }
        } catch (error) {
            RegistrarLogErro(error, "handleRegistradorDePedidos")
        }
        setLoading(false)
    }

    const handleFatura = async () => {
        setLoading(true)
        try {
            if (configuracoes.user.perfil === "ADMINISTRADOR") {
                window.open(
                    "https://sistema.appclientefiel.com.br/web/verassinaturafornecedor/ver",
                    "_blank",
                    "noopener"
                )
            } else {
                enqueueSnackbar(
                    "Infelizmente seu perfil não tem acesso ao sistema administrativo.",
                    { variant: "warning" }
                )
            }
        } catch (error) {
            enqueueSnackbar("Houve um erro ao direcionar para o sistema administrativo.", {
                variant: "error",
            })
        }
        setLoading(false)
    }

    const handleSistemaAdm = async () => {
        setLoading(true)
        try {
            if (configuracoes.user.perfil === "ADMINISTRADOR") {
                window.open(
                    RepresentanteSelector.getRepresentante().getUrlSistemaAdministrativo(),
                    "_blank",
                    "noopener"
                )
            } else {
                enqueueSnackbar(
                    "Infelizmente seu perfil não tem acesso ao sistema administrativo.",
                    { variant: "warning" }
                )
            }
        } catch (error) {
            enqueueSnackbar("Houve um erro ao direcionar para o sistema administrativo.", {
                variant: "error",
            })
        }
        setLoading(false)
    }

    const izzas = [
        {
            key: "clientefiel.app",
            value: "https://chromewebstore.google.com/search/Izza%20Bot?hl=pt-BR&utm_source=ext_sidebar",
        },
        {
            key: "pinn.delivery",
            value: "https://chrome.google.com/webstore/detail/pinn-delivery/clmomhndbepilodkepckcfmppakgelgi?hl=pt-BR",
        },
    ]

    const getUrlBotWhatsApp = () => {
        let host = window.location.hostname
        let hostReplaced = host.replace("painel.", "")

        let objIzza = izzas.find(item => item.key == hostReplaced)

        if (objIzza) {
            return objIzza.value
        }

        return "https://chromewebstore.google.com/search/Izza%20Bot?hl=pt-BR&utm_source=ext_sidebar"
    }

    const handleIzzaBot = async () => {
        try {
            setLoading(true)
            const parametros = await buscarParametros()
            if (parametros.modoIzza > 0) {
                localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
                window.open(getUrlBotWhatsApp(), "_blank")
            } else {
                enqueueSnackbar("Esse usuário não possui atentende virtual contratado.", {
                    variant: "warning",
                })
            }
        } catch (error) {
            enqueueSnackbar("Houve um erro ao direcionar para izza bot.", { variant: "error" })
            RegistrarLogErro(error, "handleIzzaBot")
        }
        setLoading(false)
    }

    // DELIVERY_BASICO / DELIVERY veem apenas o menu Pedidos, por isso ficam fora dos perfis completos
    const PERFIS_COMPLETOS = ["ADMINISTRADOR", "CLIENTEFIEL"]
    const PERFIS_ADM = ["ADMINISTRADOR", "CLIENTEFIEL"]
    const PERFIS_CLIENTEFIEL = ["CLIENTEFIEL"]
    // Perfis que podem acessar o Cardápio: os completos + o perfil dedicado DELIVERY_CARDAPIO
    const PERFIS_CARDAPIO = [...PERFIS_COMPLETOS, "DELIVERY_CARDAPIO"]
    // Perfis que podem acessar o Caixa: os completos + os perfis de delivery
    const PERFIS_CAIXA = [...PERFIS_COMPLETOS, "DELIVERY_BASICO", "DELIVERY", "DELIVERY_CARDAPIO"]

    const temPerfilCompleto = () => {
        if (!PERFIS_COMPLETOS.includes(configuracoes.user.perfil)) {
            enqueueSnackbar("Seu perfil não tem permissão para acessar essa funcionalidade.", {
                variant: "warning",
            })
            return false
        }
        return true
    }
    const temPerfilADM = () => {
        if (!PERFIS_ADM.includes(configuracoes.user.perfil)) {
            enqueueSnackbar("Seu perfil não tem permissão para acessar essa funcionalidade.", {
                variant: "warning",
            })
            return false
        }
        return true
    }
    const temPerfilClienteFiel = () => {
        if (!PERFIS_CLIENTEFIEL.includes(configuracoes.user.perfil)) {
            enqueueSnackbar("Seu perfil não tem permissão para acessar essa funcionalidade.", {
                variant: "warning",
            })
            return false
        }
        return true
    }
    const temPerfilCardapio = () => {
        if (!PERFIS_CARDAPIO.includes(configuracoes.user.perfil)) {
            enqueueSnackbar("Seu perfil não tem permissão para acessar essa funcionalidade.", {
                variant: "warning",
            })
            return false
        }
        return true
    }
    const temPerfilCaixa = () => {
        if (!PERFIS_CAIXA.includes(configuracoes.user.perfil)) {
            enqueueSnackbar("Seu perfil não tem permissão para acessar essa funcionalidade.", {
                variant: "warning",
            })
            return false
        }
        return true
    }

    const handleCaixa = async () => {
        if (!temPerfilCaixa()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/caixa")

        if (!window.getCookie("infoCaixa")) {
            enqueueSnackbar("Aqui você controla seu fluxo de caixa.")
            window.setCookie("infoCaixa", "true", 9999)
        }
    }

    const handleCardapio = () => {
        if (!temPerfilCardapio()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/ferramenta/edicao-cardapio/produtos")

        if (!window.getCookie("infoCardapio")) {
            enqueueSnackbar("Aqui você pode editar seu cardápio.")
            window.setCookie("infoCardapio", "true", 9999)
        }
    }

    const handleCardapioMassa = () => {
        if (!temPerfilCardapio()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/ferramenta/edicao-cardapio/massa")
    }

    const handleCardapioInsumos = () => {
        if (!temPerfilCardapio()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/ferramenta/edicao-cardapio/insumos")
    }

    const handleCardapioFichaTecnica = () => {
        if (!temPerfilCardapio()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/ferramenta/edicao-cardapio/ficha-tecnica")
    }

    const handleCardapioHistorico = () => {
        if (!temPerfilCardapio()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/ferramenta/edicao-cardapio/historico")
    }

    const handleParametros = () => {
        if (!temPerfilClienteFiel()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/parametros-gerais")
    }

    const handleParametrosDelivery = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/configuracao-delivery/parametros-delivery")
    }

    const handleParametrosAvancados = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/configuracao-delivery/parametros-avancados")
    }

    const handlePedidosAgendados = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/pedidos-agendados")
    }

    const handleAgendamentoPeriodos = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/agendamento-periodos")
    }

    const handleAgendamentoConfiguracoes = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/agendamento-configuracoes")
    }

    const handleIntegracoes = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/configuracao-delivery/parametros-integracao")
    }

    const handleGaleria = () => {
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/ferramenta/galeria")
    }

    const handleAreaDeEntrega = () => {
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/ferramenta/definir-area-de-entrega")

        if (!window.getCookie("infoAreaDeEntrega")) {
            enqueueSnackbar("Aqui você pode editar sua área de entrega.")
            window.setCookie("infoAreaDeEntrega", "true", 9999)
        }
    }

    const handleAgendamentoDeEntrega = () => {
        if (!parametros.PUBLIC_HABILITAR_AGENDAMENTO) {
            enqueueSnackbar("Este usuário não possui agendamento de entrega habilitado.", {
                variant: "warning",
            })

            return
        }

        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/agendamento")

        if (!window.getCookie("infoAgendamentoDeEntrega")) {
            enqueueSnackbar("Aqui você pode editar seus turnos de agendamento de pedidos.")
            window.setCookie("infoAgendamentoDeEntrega", "true", 9999)
        }
    }

    const handlePDVoz = () => {
        history.push("/servicos/modulo/pdvoz")
    }

    const handleNotaFiscal = async () => {
        try {
            setLoading(true)
            const parametros = await buscarParametros()
            if (parametros.ativarPlugNotas === true) {
                localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
                history.push("servicos/modulo/nota-fiscal")
                if (!window.getCookie("infoNotasFiscais")) {
                    enqueueSnackbar("Aqui você pode emitir notas fiscais dos pedidos.")
                    window.setCookie("infoNotasFiscais", "true", 9999)
                }
            } else {
                enqueueSnackbar("Esse usuário não ativou o plug notas.", {
                    variant: "warning",
                })
            }
        } catch (error) {
            enqueueSnackbar("Houve um erro ao direcionar o modulo de nota fiscal.", {
                variant: "error",
            })
            RegistrarLogErro(error, "handleNotaFiscal")
        }
        setLoading(false)
    }

    const handleGeradorQrCode = () => {
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/gerador-de-qrcode")

        if (!window.getCookie("infoGeradorQrCode")) {
            enqueueSnackbar("Aqui você pode gerar um QRcode a partir de qualquer link.")
            window.setCookie("infoGeradorQrCode", "true", 9999)
        }
    }

    const handleAvaliacaoDelivery = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/avaliacao-delivery")
    }

    const handleClientes = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/clientes")
    }

    const handlePesquisaSatisfacaoFornecedor = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/pesquisa-satisfacao-fornecedor")
    }

    const handleDadosFornecedor = () => {
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/dados-fornecedor")
    }

    const handleBairrosEspecificos = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/atribuir-bairros")
    }

    const handleBairrosPorRegiao = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/bairros")
    }

    // Decide qual tela abrir no link "bairros", replicando o LayoutFornecedorMENU do sistemaadm:
    //   isCalculoFretePorRaio()        = calculoEntrega > 0                      -> AtribuirFaixasDistanciaFornecedor
    //   isUtilizarBairrosEspecificos() = tipoEntregaBairro == POR_BAIRROS_ESPECIFICO (1) -> AtribuirRegiaoFornecedor
    //   senao                                                                   -> AtribuirBairrosFornecedor
    // Mapeamento das telas (os nomes de rota no React nao seguem o dominio):
    //   AtribuirRegiaoFornecedor  = especifico (RegiaoEstabelecimento / endereco/bairros)     -> /servicos/modulo/bairros
    //   AtribuirBairrosFornecedor = padrao/centralizado (BairroEstabelecimento / bairros-db)  -> /servicos/modulo/atribuir-bairros
    const handleBairros = async () => {
        if (!temPerfilCompleto()) return

        const idConfig = configuracoes?.user?.parametros?.estabelecimento?.id
        const idAtual = getIdEstabelecimentoAtual() || idConfig

        let calculoEntrega = configuracoes?.user?.parametros?.calculoEntrega
        let tipoEntregaBairro = configuracoes?.user?.parametros?.tipoEntregaBairro

        // Multi-loja: os parametros do config refletem a loja logada; se a loja
        // selecionada no seletor difere, busca os parametros da loja atual.
        if (idAtual && idConfig && String(idAtual) !== String(idConfig)) {
            setLoading(true)
            try {
                const resp = await parametrosId(idAtual, autorizacao)
                if (resp && !resp.retornoErro) {
                    calculoEntrega = resp.calculoEntrega
                    tipoEntregaBairro = resp.tipoEntregaBairro
                }
            } catch (error) {
                RegistrarLogErro(error, "handleBairros", String(idAtual))
            } finally {
                setLoading(false)
            }
        }

        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))

        if (Number(calculoEntrega) > 0) {
            history.push("/servicos/modulo/faixas-distancia")
        } else if (Number(tipoEntregaBairro) === 1) {
            history.push("/servicos/modulo/bairros") // especifico (AtribuirRegiao)
        } else {
            history.push("/servicos/modulo/atribuir-bairros") // padrao (AtribuirBairros)
        }
    }

    const handleEnderecosBloqueados = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/enderecos-bloqueados")
    }

    const handleFaixasDistancia = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/faixas-distancia")
    }

    const handleFormasDePagamento = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/configuracao-formas-pagamento")
    }

    const handleImportarClientes = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/importacao-clientes")
    }

    const handlePerguntasPesquisaSatisfacao = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/perguntas-pesquisa-satisfacao")
    }

    const handlePreferenciasImpressao = () => {
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/texto-impressao")
    }

    const handleIntegracaoOpenDelivery = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/integracao-opendelivery")
    }

    const handleTestarOpenDelivery = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/testar-opendelivery")
    }

    const handleUsuariosPainel = () => {
        // Gestao de usuarios: exclusivo da equipe Cliente Fiel
        if (!temPerfilClienteFiel()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/usuarios")
    }

    const handleOpenDeliveryIntegradores = () => {
        // Cadastro dos parceiros homologados: exclusivo da equipe Cliente Fiel
        if (!temPerfilClienteFiel()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/opendelivery-integradores")
    }

    const handleTelefonesBloqueados = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/telefones-bloqueados")
    }

    const handleTurnos = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/horarios-delivery")
    }

    const handleEntregadores = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/entregadores")
    }

    const handleNotificacoes = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/notificacoes")
    }

    const handleNotificacaoPush = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/notificacao-push")
    }

    const handleIntegracaoWhatsapp = () => {
        if (!temPerfilCompleto()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/integracao-whatsapp")
    }

    const handleHome = () => {
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        // ADMINISTRADOR e CLIENTEFIEL têm como início a tela de resumo; demais perfis, a lista de serviços.
        history.push(
            ["ADMINISTRADOR", "CLIENTEFIEL"].includes(configuracoes?.user?.perfil)
                ? "/servicos/modulo/resumo?inicial=1"
                : "/servicos"
        )
    }

    const handleConversasWhatsapp = () => {
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/conversas-whatsapp")
    }

    const handleCriarTemplateWhatsapp = () => {
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/criar-template-whatsapp")
    }

    const handleEnvioTemplateWhatsappGrupo = () => {
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/envio-template-whatsapp-grupo")
    }

    const handleQRCodesMesa = () => {
        history.push("/servicos/modulo/pedido-de-mesa")
    }

    const handleHistoricoVersoes = () => {
        history.push("/historico-versoes")
    }

    const handleBanners = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/banners")
    }

    const handleConfiguracaoFiscal = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/fiscal/configuracao-fiscal")
    }

    const handleCuponsDesconto = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/cupons/desconto")
    }

    const handleDadosBancarios = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/dados-bancarios")
    }

    const handleMarketingAutomatico = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/marketing/marketing-automatico")
    }

    const handleParametrosClienteFiel = () => {
        if (!temPerfilClienteFiel()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/configuracao-delivery/parametros-cliente-fiel")
    }

    const handlePromocaoFidelidade = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/promocao-fidelidade")
    }

    const handlePromocoes = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/promocoes")
    }

    const handleSelosPremiadosFornecedor = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/selos-premiados")
    }

    const handleBrindesResgatados = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/brindes-resgatados")
    }

    const handleCartelas = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/cartelas")
    }

    const handleComparativoUnidades = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/comparativo-unidades")
    }

    const handleEmissaoCupomFiscal = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/fiscal/emissao-cupom-fiscal")
    }

    const handleEmissoesParaMeuCNPJ = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/fiscal/emissoes-para-meu-cnpj")
    }

    const handleEstrategias = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/estrategias")
    }

    const handleExtratoDetalhado = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/pix/extrato-detalhado")
    }

    const handleExtratoPagarme = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/pix/extrato-pagarme")
    }

    const handleHistoricoCaixa = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/historico-caixa")
    }

    const handleHistoricoFechamentos = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/historico-fechamentos")
    }

    const handleHistoricoAlteracoes = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/historico-alteracoes")
    }

    const handleHistoricoMesas = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/historico-mesas")
    }

    const handleIndicacoesAmigos = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/indicacoes-amigos")
    }

    const handleListarProdutos = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/listar-produtos")
    }

    const handleModulosContratados = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/modulos-contratados")
    }

    const handleAssinatura = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/assinatura")
    }

    const handlePosicaoClientes = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/posicao-clientes")
    }

    const handleRelatorioPedidos = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/relatorio-pedidos")
    }

    const handleResumo = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/resumo")
    }

    const handleCoresAplicativo = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/editar-layout/cores-aplicativo")
    }

    const handleCadastroAplicativo = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/editar-layout/cadastro-aplicativo")
    }

    const handleParametrosAplicativo = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/editar-layout/parametros-aplicativo")
    }

    const handleArquivosAplicativo = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/editar-layout/arquivos-aplicativo")
    }

    const handleContratoAplicativo = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/editar-layout/contrato-aplicativo")
    }

    const handleEstabelecimentosAplicativo = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/editar-layout/estabelecimentos-aplicativo")
    }

    const handleRespostasPersonalizadasIzza = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/respostas-personalizadas-izza")
    }

    const handleModeloIzzaGPT = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/modelo-izza-gpt")
    }

    const handleEnviosIzza = () => {
        if (!temPerfilADM()) return
        localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
        history.push("/servicos/modulo/envios-izza")
    }

    useEffect(() => {
        let alertInterval = null

        const handleOfflineEvent = () => {
            alertStart("Você perdeu a conexão com a Internet.", "error")

            alertInterval = setInterval(
                () => alertStart("Você está sem conexão com a Internet.", "error"),
                10000
            )
        }

        const handleOnlineEvent = () => {
            alertStart("Você foi reconectado.", "success")

            if (alertInterval) clearInterval(alertInterval)
        }

        const offlineEventListener = window.addEventListener("offline", handleOfflineEvent)
        const onlineEventListener = window.addEventListener("online", handleOnlineEvent)

        return () => {
            window.removeEventListener("offline", offlineEventListener)
            window.removeEventListener("online", onlineEventListener)
            if (alertInterval) clearInterval(alertInterval)
        }
    }, [])

    return (
        <>
            <ServicosContext.Provider
                value={{
                    autorizacao,
                    handleAceitadorDePedidos,
                    handleCaixa,
                    handleIzzaBot,
                    handleSistemaAdm,
                    handleNotaFiscal,
                    handleRegistradorDePedidos,
                    handleCardapio,
                    handleCardapioMassa,
                    handleCardapioInsumos,
                    handleCardapioFichaTecnica,
                    handleCardapioHistorico,
                    handleParametros,
                    handleParametrosDelivery,
                    handleParametrosAvancados,
                    handlePedidosAgendados,
                    handleAgendamentoPeriodos,
                    handleAgendamentoConfiguracoes,
                    handleGaleria,
                    handlePedidoDeMesa,
                    buscarParametros,
                    buscarParametrosLogin,
                    acessarImagensTematicas,
                    handleGeradorQrCode,
                    handleHome,
                    handleIntegracoes,
                    handleAreaDeEntrega,
                    handleAgendamentoDeEntrega,
                    handlePDVoz,
                    handleFatura,
                    handleAvaliacaoDelivery,
                    handleClientes,
                    handlePesquisaSatisfacaoFornecedor,
                    handleDadosFornecedor,
                    handleBairrosEspecificos,
                    handleBairrosPorRegiao,
                    handleBairros,
                    handleEnderecosBloqueados,
                    handleFaixasDistancia,
                    handleFormasDePagamento,
                    handleImportarClientes,
                    handlePerguntasPesquisaSatisfacao,
                    handlePreferenciasImpressao,
                    handleTelefonesBloqueados,
                    handleIntegracaoOpenDelivery,
                    handleTestarOpenDelivery,
                    handleOpenDeliveryIntegradores,
                    handleUsuariosPainel,
                    handleTurnos,
                    handleEntregadores,
                    handleNotificacoes,
                    handleNotificacaoPush,
                    handleIntegracaoWhatsapp,
                    handleConversasWhatsapp,
                    handleCriarTemplateWhatsapp,
                    handleEnvioTemplateWhatsappGrupo,
                    handleQRCodesMesa,
                    handleHistoricoVersoes,
                    handleBanners,
                    handleConfiguracaoFiscal,
                    handleCuponsDesconto,
                    handleDadosBancarios,
                    handleMarketingAutomatico,
                    handleParametrosClienteFiel,
                    handlePromocaoFidelidade,
                    handlePromocoes,
                    handleSelosPremiadosFornecedor,
                    handleBrindesResgatados,
                    handleCartelas,
                    handleComparativoUnidades,
                    handleEmissaoCupomFiscal,
                    handleEmissoesParaMeuCNPJ,
                    handleEstrategias,
                    handleExtratoDetalhado,
                    handleExtratoPagarme,
                    handleHistoricoCaixa,
                    handleHistoricoFechamentos,
                    handleHistoricoAlteracoes,
                    handleHistoricoMesas,
                    handleIndicacoesAmigos,
                    handleListarProdutos,
                    handleModulosContratados,
                    handleAssinatura,
                    handlePosicaoClientes,
                    handleRelatorioPedidos,
                    handleResumo,
                    handleCoresAplicativo,
                    handleCadastroAplicativo,
                    handleParametrosAplicativo,
                    handleArquivosAplicativo,
                    handleContratoAplicativo,
                    handleEstabelecimentosAplicativo,
                    handleRespostasPersonalizadasIzza,
                    handleModeloIzzaGPT,
                    handleEnviosIzza,
                }}
            >
                <DialogAvisoFatura />
                <Routes />
            </ServicosContext.Provider>
        </>
    )
}
